export interface Message {
    messageId: string;
    messageTitle: string;
    messageText: string;
    sourceApplication: string;
    sourceApplicationUrl: string;
    important?: boolean;
    type: string;
    creationDate: Date;
    expirationDate?: Date;
    metadata?: object;
    read: boolean;
    useCustomUrlClick?: boolean;
    visible?: boolean;
    canDelete?: boolean;
    parentMessageId?: string;
    additionalInfo?: string;
    additionalInfoUrl?: string;
    supportStatusChanges?: boolean;
    status?: string;
    commitedAt?: Date;
    commitedBy?: string;
    closedAt?: Date;
    closedBy?: string;
}

export interface MessageFilter {
    id: string; // Translation key
    name: string; // Translated value
    value: boolean; //Checked?
    type: string; // Filter type
}

export type MessageFilterList = Array<MessageFilter>;
